import session from "../stores/session";

export default function hasPermission(module, permission) {
    if (permission === 'BD-PLUS' && !session.user.permissions.includes(module + '-' + permission)) return false;
    if (session.user.user_type === 'Team Leader' && module !== "ADMIN") {
        return true;
    } else if ((session.user.user_type === 'Agent' && ["WORKFLOW", "PURCHASE", "WHOLESALER"].includes(permission))) {
        return true;
    } else if (session.user.permissions.indexOf(module + '-' + permission) !== -1) {
        return true
    } else {
        return false;
    }
}
